<template>
    <div class="customer-paper-dialog">
        <el-dialog
            title="下载"
            width="40%"
            :visible="visible"
            destroy-on-close
            append-to-body
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="closeVisible(false)"
        >
            <div class="customer-paper-do-box">
                <el-radio-group v-model="downFileType" size="small">
                    <el-radio label="word">Word</el-radio>
                    <!-- <el-radio label="pdf">PDF</el-radio> -->
                </el-radio-group>
            </div>
                <span slot="footer">
                <el-button size="mini" @click="closeVisible(false)">取消</el-button>
                <el-button type="primary" size="mini" @click="confirmHandle">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import store from '@/store/index';
import { Message } from 'element-ui';
export default {
    components: { },
    props: {
        detailData: {
            type: Object,
            default: () => {
                return {};
            }
        }

    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const { userCode } = store.getters.user;
        const isCurrentAuth = computed(() => {
            return userCode === props.detailData.customerOwnerCode;
        });
        const downFileType = ref('word');
        const visible = ref(false);
        const showParams = ref({});

        const show = (val = {}) => {
            visible.value = true;
            showParams.value = val;
        };
        const closeVisible = (val = false) => {
            visible.value = val;
        };
        const confirmHandle = () => {
            const url = downFileType.value === 'word' ? showParams.value.docUrl : showParams.value.pdfUrl;
            if (!url) {
                return Message.warning('当前一页纸数据未生成,请生成后再下载');
            }
            window.open(url, '_blank');
        };
        return {
            emit,
            visible,
            isCurrentAuth,
            downFileType,
            confirmHandle,
            show,
            closeVisible
        };
    }
};
</script>
<style lang="less" scoped>
.customer-paper-do-box{
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
